import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { OrganizationProvider } from '@app/api';

import { I18n } from './i18n';
import { createStore } from './store';
import { ThemeProvider } from '@app/theme';
import { setReduxStore } from './queries';

import 'lib/validators';
import { MainRouter } from './MainRouter';
import { MaintenanceGate, NotFound, ToastContainer } from '@app/core';
import {
  ConnectingAsGate,
  PlanIdProvider,
  UnlockFeatureContextProvider,
} from './components';
import { AnalyticsProvider, initSentry } from '@app/analytics';

const { store } = createStore();
const queryClient = new QueryClient();
setReduxStore(store);
initSentry({
  dsn: process.env.NX_SENTRY_DSN as string,
  app: 'bilendi-ux-client',
});

export class App extends React.Component<{}> {
  render() {
    return (
      <I18nextProvider i18n={I18n}>
        <Provider store={store}>
          <ThemeProvider>
            <QueryClientProvider client={queryClient}>
              <Sentry.ErrorBoundary fallback={<NotFound />}>
                <MaintenanceGate>
                  <OrganizationProvider>
                    <BrowserRouter>
                      <AnalyticsProvider container="Cc0Krh34">
                        <PlanIdProvider>
                          <UnlockFeatureContextProvider>
                            <ConnectingAsGate>
                              <MainRouter />
                            </ConnectingAsGate>
                          </UnlockFeatureContextProvider>
                        </PlanIdProvider>
                      </AnalyticsProvider>
                    </BrowserRouter>
                  </OrganizationProvider>
                </MaintenanceGate>
              </Sentry.ErrorBoundary>
            </QueryClientProvider>
            <ToastContainer />
          </ThemeProvider>
        </Provider>
      </I18nextProvider>
    );
  }
}
